export default "__VITE_ASSET__Bkhx0o$C__"